export default {
  device_size: {
    mobile_s: '320px',
    mobile_m: '375px',
    mobile_l: '425px',
    tablet: '768px',
    laptop: '1024px',
    laptop_l: '1440px',
    desktop: '2560px',
  },
};
